import { useLayoutEffect, useMemo, useRef, useState } from 'react'

import { useAttributeContext } from './useAttributeContext'

type UseLongTextAttributeStateProps = {
    isLoading?: boolean
}

export function useLongTextAttributeState({ isLoading }: UseLongTextAttributeStateProps) {
    const { value, isEditingValue, isEditable } = useAttributeContext<string>()

    const isEmpty = !isLoading && !value

    const [showFullText, setShowFullText] = useState(false)

    const wrapperRef = useRef<HTMLDivElement>(null)

    const editorMaxHeight = useRef(0)
    useLayoutEffect(() => {
        if (wrapperRef.current) {
            editorMaxHeight.current = wrapperRef.current.clientHeight
        }
    }, [showFullText, value])

    return useMemo(
        () => ({
            isEmpty,
            value,
            isEditingValue,
            isEditable,
            showFullText,
            setShowFullText,
            wrapperRef,
            editorMaxHeight: editorMaxHeight.current,
        }),
        [isEmpty, value, isEditingValue, isEditable, showFullText]
    )
}
